export default [
  {
    header: 'Documentation',
  },
  {
    title: 'Glossary',
    route: 'glossary',
    icon: 'LayersIcon',
  },
]
